import React                from "react";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import ScheduleEdit         from "./ScheduleEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Schedule List
 * @returns {React.ReactElement}
 */
function ScheduleList() {
    const { fetch, load } = useList("schedule");

    const data = Store.useState("schedule");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("schedule");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "scheduleID", elemID, "name");

    return <Main>
        <Header message="SCHEDULES_NAME" icon="schedule">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="SCHEDULES_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"          message="GENERAL_NAME"        isTitle />
                    <TableHeader field="categoryName"  message="CATEGORIES_SINGULAR" />
                    <TableHeader field="forNazar"      message="SCHEDULES_FOR_NAZAR" align="center" maxWidth="110" />
                    <TableHeader field="timeTableText" message="SCHEDULES_SINGULAR"  grow="2" noSorting />
                    <TableHeader field="status"        message="GENERAL_STATUS"      align="center" maxWidth="100" />
                    <TableHeader field="finalPosition" message="GENERAL_POSITION"    align="center" maxWidth="80" hideMobile />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.scheduleID} elemID={elem.scheduleID}>
                        <TableCell message={elem.name}          />
                        <TableCell message={elem.categoryName}  />
                        <TableCell message={elem.forNazarText}  />
                        <TableCell message={elem.timeTableText} />
                        <TableCell message={elem.statusName}    textColor={elem.statusColor} />
                        <TableCell message={elem.finalPosition} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="SCHEDULES_EDIT_TITLE"   />
                    <TableAction action="COPY"   message="SCHEDULES_COPY_TITLE"   />
                    <TableAction action="DELETE" message="SCHEDULES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <ScheduleEdit
            open={action.isVCCE}
            isCopy={action.isCopy}
            elemID={elemID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="SCHEDULES_DELETE_TITLE"
            message="SCHEDULES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

export default ScheduleList;
